<template>
  <div id="qrCode" ref="qrCodeDiv"></div>
</template>

<script>
import QRCode from 'qrcodejs2';

export default {
  name: "QrCode",
  mounted: function () {

  },
  methods: {
    bindQRCode: function (QrCodeDate, memberId, sectionId, pxbId, pxbName, token) {
      let goToUrl = 'https://hw.sxbicsp.cn/qrCode/videoAttendance?date=' + QrCodeDate + '&pxbName=' + pxbName + ' &sectionId=' + sectionId + '&pxbId=' + pxbId +'&memberId=' + memberId + '&token=' + token
      // let goToUrl = 'https://hw.sxbicsp.cn/qrCode/videoAttendance?date=1657607512137&memberId=e01b4798a3e542f4884005519fd342c6&sectionId=ad3a6d7245d9442b8767c425af2fc024&pxbId=5053&pxbName=20220602电工班&token=054dc286dd954979995998c0f9f2ddb0'
      console.log(goToUrl.replace(/\s+/g, ''), pxbName)
      new QRCode(this.$refs.qrCodeDiv, {
        text: goToUrl.replace(/\s+/g, ''),
        width: 200,
        height: 200,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })
    },
    clearQRCode: function () {
      this.$refs.qrCodeDiv.innerHTML = ''
    }
  }
}
</script>

<style scoped lang="scss">

#qrCode {
  width: 220px;
  height: 220px;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #222;
  border-radius: 10px;
}

img {
  width: 220px;
  height: 220px;
  background-color: #fff; //设置白色背景色
}

</style>